import React, { FunctionComponent, useContext, useState } from 'react'

type RootState = {
  loadList: number
}

type RootFunctions = {
  setLoadList(): void
}

const InitialState: RootState = {
  loadList: 0,
}

export const MyReservationsContext = React.createContext<[RootState, (state: any) => void]>([InitialState, () => {
}])

export const MyReservationsProvider: FunctionComponent = ({ children }) => {
  const [state, setState] = useState<RootState>(InitialState)

  return (
    <MyReservationsContext.Provider value={[state, setState]}>
      {children}
    </MyReservationsContext.Provider>
  )
}

export const useMyReservations = (): RootFunctions & RootState => {
  const [state, setState] = useContext(MyReservationsContext)

  const setLoadList = () => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
    }))
  }

  return {
    setLoadList,
    ...state,
  }
}
